import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

const MobileStart = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const kt = searchParams.get("kt") || "";

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [shopId, setShopId] = useState(0);

  useEffect(() => {
    const fetchStart = async () => {
      if (!kt) {
        setError("잘못된 접근입니다. (토큰 없음)");
        setLoading(false);
        return;
      }

      try {
        const res = await axios.get("/api/kiosk/mobile_start", {
          params: { kt },
          withCredentials: true,
        });

        const data = res.data || {};

        if (!data.ok) {
          setError(data.message || "주문 시작 정보를 불러오지 못했습니다.");
          setLoading(false);
          return;
        }

        if (data.redirect) {
          const url = new URL(data.redirect, window.location.origin);
          navigate(`/kiosk/mobile/cart?kt=${encodeURIComponent(kt)}`, { replace: true });
          return;
        }

        setShopId(Number(data.shop_id || 0));
      } catch (err) {
        setError(err.response?.data?.message || "주문 시작 정보를 불러오지 못했습니다.");
      } finally {
        setLoading(false);
      }
    };

    fetchStart();
  }, [kt, navigate]);

  const guestContinueUrl = `/kiosk/mobile/cart?kt=${encodeURIComponent(kt)}`;
  const loginRedirect = encodeURIComponent(`/kiosk/mobile/start?kt=${encodeURIComponent(kt)}`);

  return (
    <>
      <style>{`
        body { background:#f6f7f9; }
        .card { border:0; border-radius:14px; }
      `}</style>

      <div className="container py-4">
        {loading ? (
          <div className="card p-3">불러오는 중...</div>
        ) : error ? (
          <div className="card p-3">
            <div className="fw-bold text-danger mb-2">진입 오류</div>
            <div className="text-muted small">{error}</div>
          </div>
        ) : (
          <>
            <div className="mb-3">
              <h4 className="fw-bold">주문을 진행할게요</h4>
              <div className="text-muted">로그인 없이도 결제까지 가능해요.</div>
            </div>

            <div className="card p-3 mb-3">
              <div className="fw-bold mb-2">비회원으로 진행</div>
              <div className="text-muted small mb-3">바로 결제 가능합니다.</div>
              <button
                type="button"
                className="btn btn-primary w-100"
                onClick={() => navigate(guestContinueUrl)}
              >
                비회원으로 계속
              </button>
            </div>

            <div className="card p-3">
              <div className="fw-bold mb-2">로그인 후 진행</div>
              <div className="text-muted small mb-3">
                주문내역/적립 등을 쓰려면 로그인하세요.
              </div>

              <a
                href={`/login?redirect=${loginRedirect}`}
                className="btn btn-outline-secondary w-100"
              >
                로그인하기
              </a>
            </div>

            <div className="text-center text-muted small mt-3">
              QR이 만료되면 키오스크에서 다시 QR을 띄워주세요.
            </div>

            {shopId > 0 ? (
              <div className="text-center text-muted small mt-2">매장 번호: {shopId}</div>
            ) : null}
          </>
        )}
      </div>
    </>
  );
};

export default MobileStart;